import { getNoticeUnread } from "@/api/request/survey";
export interface mobileTableType {
  isUnReadNum: number;
  isUnRead: boolean;
}
export const tableBar = {
  state: {
    isUnReadNum: 0,
    isUnRead: false,
  } as mobileTableType,
  getters: {
    unReadNum: (state: mobileTableType) => {
      return state.isUnReadNum;
    },
    isUnRead: (state: mobileTableType) => {
      return state.isUnRead;
    },
  },
  mutations: {
    SET_TABLEBRT_NUM: (state: any, status: number) => {
      state.isUnReadNum = status;
    },
    SET_UN_READ: (state: any, status: boolean) => {
      state.isUnRead = status;
    },
  },
  actions: {
    GetNumber({ commit }: any) {
      return new Promise((resolve, reject) => {
        getNoticeUnread()
          .then((res) => {
            commit("SET_TABLEBRT_NUM", res.data);
            commit("SET_UN_READ", !!res.data);
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};
